/** Indian Rupee formatter — matches BigxBook billing/billingEngine.formatCurrency */
export function formatCurrency(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '₹0.00';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}
